/** The actionIds this page has sent lately. A pushed event carrying one is news only to other tabs. */
const recent: string[] = [];
export const isMine = (actionId: string | undefined) => actionId !== undefined && recent.includes(actionId);

/** A fresh actionId, remembered so the socket can tell our own doings from news. */
export function newActionId(): string {
  const id = uuid();
  recent.push(id);
  if (recent.length > 200) recent.shift();
  return id;
}

/** RFC 4122 v4 id. `crypto.randomUUID` exists only in secure contexts; getRandomValues works everywhere. */
function uuid(): string {
  if (typeof crypto.randomUUID === 'function') return crypto.randomUUID();
  const b = crypto.getRandomValues(new Uint8Array(16));
  b[6] = (b[6]! & 0x0f) | 0x40;
  b[8] = (b[8]! & 0x3f) | 0x80;
  const h = [...b].map((x) => x.toString(16).padStart(2, '0')).join('');
  return `${h.slice(0, 8)}-${h.slice(8, 12)}-${h.slice(12, 16)}-${h.slice(16, 20)}-${h.slice(20)}`;
}

const DEVICE_KEY = 'wyn.device';

/**
 * A random id for this browser, kept in localStorage. The server hashes it to spot trades between
 * accounts on one device. Without storage (a private window) it lives only as long as the page.
 */
let memoryDevice: string | null = null;
export function deviceId(): string {
  try {
    const existing = localStorage.getItem(DEVICE_KEY);
    if (existing) return existing;
    const id = uuid();
    localStorage.setItem(DEVICE_KEY, id);
    return id;
  } catch {
    return (memoryDevice ??= uuid());
  }
}
